var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.92,
    d: "M7.07228 0C10.9782 0 14.1446 3.1654 14.1446 7.07011C14.1446 8.67479 13.6098 10.1546 12.7087 11.3412L17.7179 16.3546C18.0943 16.7314 18.094 17.3418 17.7171 17.718C17.3403 18.0943 16.7297 18.0939 16.3533 17.7172L11.3447 12.7048C10.1577 13.6056 8.67746 14.1402 7.07228 14.1402C3.16637 14.1402 0 10.9748 0 7.07011C0 3.1654 3.16637 0 7.07228 0ZM7.07228 1.92811C4.23163 1.92811 1.92879 4.23024 1.92879 7.07011C1.92879 9.90998 4.23163 12.2121 7.07228 12.2121C9.91294 12.2121 12.2158 9.90998 12.2158 7.07011C12.2158 4.23024 9.91294 1.92811 7.07228 1.92811Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b3623c77266fdc4b5498d44dc930d3b1.svg";
export { ForwardRef as ReactComponent };